var render, staticRenderFns
import script from "./toast.vue?vue&type=script&lang=js&"
export * from "./toast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d1b30d8', component.options)
    } else {
      api.reload('4d1b30d8', component.options)
    }
    
  }
}
component.options.__file = "client/components/toast.vue"
export default component.exports